<influencer-module-container 
    [title]="'INFLUENCER.insight.follower_by_channel.title' | translate" 
    [tooltip]="'INFLUENCER.insight.follower_by_channel.tooltip' | translate" 
    [hasNoData]="hasNoData" 
    [isFetchingData]="isFetchingData"
    [placeholderWidth]="301"
    [height]="'265px'">

    <div *ngIf="readyToShow" class="chart-area">
        <achoo-pie-chart *ngIf="!hasNoData && !isFetchingData"
            [chartData]="chartData"
            [height]="265"
            [legend]="legend"
            [chartConfig]="chartConfig"
            [overridenPiePlotOptions]="overridenPiePlotOptions">
        </achoo-pie-chart>

        <achoo-pie-chart *ngIf="hasNoData || isFetchingData"
            [chartData]="placeholderData"
            [height]="265"
            [legend]="legend"
            [chartConfig]="chartConfig"
            [overridenPiePlotOptions]="overridenPiePlotOptions">
        </achoo-pie-chart>
    </div>
</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/follower-by-channel/follower-by-channel.component.html